import StripePaymentForm from './StripePaymentForm'
export default StripePaymentForm
